import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';

import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioFuncionalidad from '../servicios/ServicioFuncionalidad';

export class Funcionalidad extends Component {
  constructor() {
    super();
    this.state = {
      paginacion: { registrosPorPagina: 20 },
      inicio: 0,
      errores: {},
      funcionalidad: {},
      mostrarModalFuncionalidad: false,
      mostrarModalConfirmacion: false
    }
  }

  asignarValoresObjeto = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);

  }

  nuevaFuncionalidad = () => {
    this.setState({ mostrarModalFuncionalidad: true, errores: {}, funcionalidad: {} })
  }

  buscarLike = (e) => {
    let { funcionalidad, paginacion } = this.state;

    servicioFuncionalidad.buscarLike(funcionalidad).then((response) => {
      if (response.data.lista.length === 0) {
        this.growl.show({ life: 6000, severity: 'error', summary: '', detail: 'No existe informaci\u00f3n con los valores ingresados, verifica tus datos' });
        paginacion['datos'] = response.data.lista;
        this.setState({ valorencontrado: response.data, paginacion });
      } else {
        this.growl.show({ life: 1000, severity: 'success', summary: '', detail: "Valores encontrados" });
        paginacion['datos'] = response.data.lista;
        this.setState({ valorencontrado: response.data.lista, paginacion });
      }
    })

  }

  componentDidMount() {
    this.obtenerPagina();
  }
  cambiaPagina(event) {
    let { paginacion } = this.state;

    paginacion.numeroPagina = event.page;
    paginacion.registrosPorPagina = event.rows;
    this.setState({ inicio: event.first, paginacion });
    this.obtenerPagina();
  }
  obtenerPagina() {
    let { paginacion } = this.state;
    servicioFuncionalidad.paginacion(paginacion).then((response) => {
      this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

      if (response.data.error === false)
        this.setState({ paginacion: response.data.objeto });


    });

  }

  cerrarModalFuncionalidad = () => {
    this.setState({ mostrarModalFuncionalidad: false, errores: {}, funcionalidad: {} })
  }

  guardarFuncionalidad = () => {
    let { funcionalidad } = this.state;
    const validacion = this.validarFormulario(funcionalidad);
    this.setState({ errores: validacion });
    if (!Object.keys(validacion).length) {
      servicioFuncionalidad.guardar(funcionalidad).then(response => {
        this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
        if (response.data.error === false) {
          this.cerrarModalFuncionalidad();
          this.obtenerPagina();
        }

      });
    }
  }

  validarFormulario = (funcionalidad) => {
    const errores = {};
    if (!funcionalidad.nombre)
      errores.nombre = "Nombre es requerido";
    if (!funcionalidad.accion)
      errores.accion = "Accion es requerida";
    return errores;
  }

  editarFuncionalidad = (rowData, column) => {

    return <div style={{display:'inline-block', justifyContent:'center'}}>
      <div className="p-col-12 p-md-4">
        <Button type="button" icon="pi-md-edit" className="p-button-success" name="editar"
          tooltip="editar" onClick={(e) => this.pre_editar(column.rowData)} >
        </Button>
      </div>
    </div>;
  }

  pre_editar = (objeto) => {
    var funcionalidadEnvio = JSON.parse(JSON.stringify(objeto));
    this.setState({ mostrarModalFuncionalidad: true, errores: {}, funcionalidad: funcionalidadEnvio });
  }

  eliminarFuncionalidad = (rowData, column) => {

    return <div style={{display:'inline-block', justifyContent:'center'}}>
      <div className="p-col-12 p-md-4">
        <Button type="button" icon="pi-md-delete" className="p-button-warning" name="eliminar"
          tooltip="eliminar" onClick={(e) => this.mostrarModalEliminar(column.rowData)} >
        </Button>
      </div>
    </div>;
  }



  mostrarModalEliminar = (objeto) => {
    this.setState({ mostrarModalConfirmacion: true, funcionalidad: objeto })
  }

  eliminar = () => {
    let { funcionalidad } = this.state;
    servicioFuncionalidad.eliminar(funcionalidad).then((response) => {
      this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
      if (response.data.error === false)
        this.setState({ fun: {}, mostrarModalConfirmacion: false });
      this.obtenerPagina();

    }).catch((error) => {
      if (error)
        return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
    });
  }

  cerrarModalConfirmacion=()=>{
    this.setState({ mostrarModalConfirmacion: false, funcionalidad: {} })
  }


  render() {

    let { funcionalidad, paginacion, inicio, errores } = this.state;

    const dialogFooter = (
      <div>
        <Button icon="pi-md-check" onClick={this.guardarFuncionalidad} label="Guardar" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" label="Cancelar" className="p-button-danger flat-btn" onClick={this.cerrarModalFuncionalidad} />
      </div>
    );

    const dialogFooterConfirmacionEliminar = (
      <div>
        <Button icon="pi-md-check" onClick={this.eliminar} label="Si estoy seguro" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={this.cerrarModalConfirmacion} label="No estoy seguro" className="p-button-danger flat-btn" />
      </div>
    );

    return (
      <div >
        <div className="card card-w-title">
          <Growl ref={(el) => this.growl = el} />
          <h1 style={{marginBottom:'30px'}}>Funcionalidad</h1>
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-4">
              <Button type="button" className="blue-grey-btn flat-btn" label="Nueva Funcialidad" name="nuevo" value="Nuevo"
                tooltip="nuevo" onClick={this.nuevaFuncionalidad} >
              </Button>
            </div>
            <div className="p-col-12" style={{marginTop:'30px', fontWeight:'bold', marginLeft:'5px'}}>
              <label htmlFor="buscar">Buscar funcionalidad:</label>
            </div>
            <div className="p-col-12 p-md-6" style={{marginLeft:'5px', marginBottom:'30px'}}>
              <InputText className="p-inputtext" placeholder="Buscar por todos los criterios " name="funcionalidad.nombre" value={funcionalidad.nombre || ''} onChange={this.asignarValoresObjeto} onKeyUp={this.buscarLike.bind(this)} />
            </div>


            <Card>
              <DataTable value={paginacion.datos} scrollable={true} scrollHeight="280px"  >
                <Column field="nombre" header="Nombre" style={{ width: '200px', textAlign:'center'}} filter={false} autoLayout={true} />
                <Column field="accion" header="Acción" style={{ width: '200px', textAlign:'center'}} filter={false} autoLayout={true} />
                <Column header="Editar" body={this.editarFuncionalidad} style={{ width: '100px', textAlign:'center'}} />
                <Column header="Eliminar" body={this.eliminarFuncionalidad} style={{ width: '100px', textAlign:'center'}} />
              </DataTable>
              <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
            </Card>
          </div>
        </div>


        <Dialog header="Funcionalidad, los campos con * son requeridos." blockScroll visible={this.state.mostrarModalFuncionalidad} modal={true} footer={dialogFooter} style={{ width: '60vw' }} onHide={this.cerrarModalFuncionalidad}>
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-2">
              <label htmlFor="nombre">* Nombre:</label>
            </div>
            <div className="p-col-12 p-md-4">
              <InputText id="nombre" name="funcionalidad.nombre" value={funcionalidad.nombre || ''} onChange={this.asignarValoresObjeto} className={errores.nombre ? 'p-error' : ''} />
              {errores.nombre ? <div> <Message severity="error" text={errores.nombre} /> </div> : null}
            </div>
            <div className="p-col-12 p-md-2">
              <label htmlFor="accion">* Acción:</label>
            </div>
            <div className="p-col-12 p-md-4">
              <InputText id="accion" name="funcionalidad.accion" value={funcionalidad.accion || ''} onChange={this.asignarValoresObjeto} className={errores.accion ? 'p-error' : ''} />
              {errores.accion ? <div> <Message severity="error" text={errores.accion} /> </div> : null}
            </div>
          </div>
        </Dialog>

        <Dialog header="Confirmación" visible={this.state.mostrarModalConfirmacion} modal={true} style={{ width: '30vw' }} footer={dialogFooterConfirmacionEliminar} onHide={this.cerrarModalConfirmacion}>
          <h2>¿Estás seguro de eliminar el metodo de pago?</h2>
        </Dialog>

      </div>

    );
  }
}